import request from '@shared/utils/request'

// 登录
export function login(data) {
  return request({
    url: '/sys-login/pc',
    method: 'post',
    data
  })
}

//退出登录
export function sysLogout() {
  return request({
    url: '/sys-login/logout',
    method: 'post'
  })
}

// 刷新token用户信息
export function restUserInfo(params) {
  return request({
    url: '/auth-service/refreshToken',
    method: 'get',
    params
  })
}
// 获取验证码
export function getVcode(params) {
  return request({
    url: '/sys-captcha/get',
    method: 'post',
    params
  })
}
